module.exports = __webpack_public_path__ + "static/media/upload_file.60f59f5b.svg";